import React from "react";
import { Icon } from "@iconify/react";
const Icons = ({
  icon,
  className,
  width,
  rotate,
  hFlip,
  vFlip,
  height,
  color,
}:any) => {
  return (
    <>
      <Icon
        width={width}
        rotate={rotate}
        hFlip={hFlip}
        icon={icon}
        className={className}
        vFlip={vFlip}
        height={height}
        color={color}
      />
    </>
  );
};

export default Icons;
